import { getGridSelectedIds, getGridSelected } from '@/utils/agGrid'
import { Assert } from '@/utils/validate'
import AbstractFinanceManage from './AbstractFinanceManage'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import { getLoading } from '@/utils/utilBaseElement'
import { getJobList, queryTotalProfit, jobAccountVerify, updateChangeState, jobVerifyByRange, updateProvisioned, updateBusinessDate } from '@/api/clearing/financeManage'
import { getUserDepartmentTeam } from '@/api/user'
import { getFilterCacheList, cacheKeys } from '@/utils/basicDataCache'
import lodash from 'lodash'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import DateUtils from '@/utils/dateUtils'
import { Once } from '@/utils/commonUtil'

const BACK_TO_FINANCE_MANAGE = 'backToFinanceManage'
export const events = { BACK_TO_FINANCE_MANAGE }

export default class BusinessCommissionHP extends AbstractFinanceManage {
  /**
     * logger
     */
  // todo 日志

  constructor(view) {
    super(view)
    this.once = new Once(this)
  }

  /**
   * 返回查询
   * @public
   */
  btnBackSearch_clickHandler(event) {
    this.$emit(events.BACK_TO_FINANCE_MANAGE)
    // this.updateState(this._view.indexState);
  }

  /**
   * @private
   * 刷新当前数据
   */
  // todo 具体分析 - 刷新 detail
  refresh() {
    // if (_job)
    //  _job.reload2(
    //   function ():void {
    //    ifthis._view.vs.selectedIndex == 1){
    //     setTabListJob();
    //    }
    //   },
    //   function ():void{
    //    LOGGER.error("booking job reload error!");
    //   });
  }

  // todo 详情和 业务提成 view
  updateResultProvisioned() {
    // this.doSearch()
    this.doSearchWithProfitAndList()
    this.$logger.log(' businessCommi 计提成功的回调 刷新列表 updateResultProvisioned')
  }

  /**
   * 查看
   * @param needChecked
   * @param detailData
   * @param gridOptions
   * @param treeDataArr
   * @param fromView
   * @returns {Promise<void>}
   * @private
   */
  async showDetailView(needChecked, detailData, gridOptions, treeDataArr, fromView) {
    if (needChecked) {
      const uuids = await getGridSelectedIds(gridOptions, 'uuid')
      await Assert.isTrue(uuids.length === 1, this.$t('Clearing.PleaseARecordToView'))
      detailData = { ...getGridSelected(gridOptions)[0] }
    }
    this.$logger.log('this dd', this._view)
    return { detailData: { ...detailData }, treeDataArr: lodash.cloneDeep(treeDataArr), fromView }
  }

  getUserDepartmentTeamHandler(results) {
    super.getUserDepartmentTeamHandler(results)
  }
  /**
   * 同组或个人查询
   */
  queryDataRole(isDepartment) {
    super.queryDataRole(isDepartment)
  }
  /**
   * 查询操作
   */
  getRoleByOpUsers(isDepartment) {
    return super.getRoleByOpUsers(isDepartment)
  }

  resultHandler(wrapper) {
    // todo 需要将前台代码，移动到后台
    // 1、刷新列表
    // 2、同步计算 右下角 数据
    super.resultHandler(wrapper)
  }

  async toQueryListWithProfitAndList(roleMap = null, queryMasterDb = false) {
    // return Promise.all([this.toQueryList(roleMap, false), this.toQueryList(roleMap, true)])
    this.toQueryList(roleMap, false)
  }
  async doSearchWithProfitAndList() {
    // return Promise.all([this.doSearch(), this.doSearch(true)])
    this.doSearch()
  }

  async doSearch(calcTotalProfit = false) {
    this._view.allJobByRole = this.$checkPermission(['role_ACPayAuth_allJob'])
    this._view.departmentJobByRole = this.$checkPermission(['role_ACPayAuth_departmentJob'])

    if (this._view.allJobByRole || !this._view.hasCheckRole) {
      this.toQueryList(null, calcTotalProfit)
    } else {
      if (this._view.departmentJobByRole) {
        if (!(this._view.departmentTeamUser && this._view.departmentJobByRole.length > 0)) {
          // User.getUserDepartmentTeam(new mx.rpc.Responder(getUserDepartmentTeamHandler, failureHandler))
          // 当前公司的部门id todo
          const departmentIds = getFilterCacheList(cacheKeys.basic_data_Department, (item) => {
            item.officeUuid === this._view.$store.getters.currentOfficeUuid
          }).map(item => item.departmentId)
          // 同组部门下的用户
          getUserDepartmentTeam({ departmentIds, branchId: this._view.$store.getters.currentOfficeId }).then(res => {
            this.getUserDepartmentTeamHandler(res.data)
          })
        } else {
          this.getUserDepartmentTeamHandler()
        }
      } else {
        this.queryDataRole(false)
      }
    }
  }

  getCommissionRule(jobType, accountPeriod) {
    const commissionRules = ColumnUtils.getBasicDataCacheList(TYPE_NAMES.basic_data_CommissionRule, (rule) => {
      if (rule.jobType === jobType && rule.accountPeriodBegin < accountPeriod && rule.accountPeriodEnd > accountPeriod) {
        return true
      }
    })

    return commissionRules ? commissionRules[0] : null
  }

  calCommission(wapper) {
    const jobs = wapper.results.list
    if (jobs) {
      const otherResult = wapper.otherResult
      if (otherResult && otherResult['chargeDate']) { // 账龄
        const chargeDateMap = otherResult['chargeDate']
        if (chargeDateMap) {
          for (const job of jobs) {
            let incoTerm = ''
            if (job.log === 'SE') {
              incoTerm = job.incoTerm
              // 计算当票账龄
            }
            if (job.receivable === '全部核销') {
              // 设置账龄
              const chargeDate = chargeDateMap[job.key]
              console.log('job.etd', job.etd, job.eta, chargeDate)
              if (job.lob === 'AE' || job.lob === 'SE') { // 出口取ETD
                job.chargeDateApart = DateUtils.getBetweenDays(chargeDate, job.etd)
              } else { // 进口取ETA
                job.chargeDateApart = DateUtils.getBetweenDays(chargeDate, job.eta)
              }
              // 计算提成金额
              const rule = this.getCommissionRule(incoTerm, job.chargeDateApart)
              const percentage = rule ? rule.percentage : 0
              job.commissionAmount = 0.01 * percentage * job.realProfit
              // console.log('job.commissionAmount', job.commissionAmount)
              // todo-shengsheng  Desc: 测试 job的commissionAmount 是否修改了
            }
          }
        }
      }
    }
  }
  toQueryList(roleMap = null, calcTotalProfit = false) {
    const { snapshotConditions: conditions, requires, pageNum, pageSize } = this._view.searchConditions
    const requestBody = { conditions, requires, roleMap, pageNum, pageSize, branchId: this.$store.getters.currentOfficeId }
    if (calcTotalProfit) {
      queryTotalProfit(requestBody).then(res => {
        super.resultHandlerForTotalProfit(res.data)
      }).finally(() => {
        // 默默的进行 就行了
      })
    } else {
      this.loading()
      getJobList(requestBody).then(res => {
        // this.calCommission(res.data) 计算提成费用移到后端，前端代码屏蔽
        // console.log('calCommission data', res.data)
        this._view.rowData = res.data.results.list
        this.resultHandler(res.data)
        this._view.searchConditions.total = Number(res.data.results.total)
      }).finally(() => {
        this.closeLoading()
      })
    }
  }

  created() {
    const currentThis = this
    this._view.gridOptions = {
      rowSelection: 'multiple',
      suppressDoubleClickExpand: true,
      suppressCellSelection: true,
      treeData: true,
      groupDefaultExpanded: 2,
      getDataPath: data => {
        return data.path.split(',')
      },
      onSelectionChanged(event) {
        currentThis.once.excute(currentThis.refreshSelectedCount)
      },
      autoGroupColumnDef: {
        headerName: this.$t('Billing.billingCharge_businessNumber'),
        field: 'jobNo',
        colId: 'jobNo',
        width: 240,
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        cellRendererParams: {
          suppressCount: true,
          suppressDoubleClickExpand: true,
          checkbox: params => {
            return true
          },
          innerRenderer: params => {
            const methodPath = this._view.documentManage.getPath('showDetailView4Business')
            return `${params.value}<i class="el-icon-search" onclick="${methodPath}('${params.data.uuid}')" style="color:#46a6ff;cursor:pointer"/>`
          }
        }
      },
      onRowDoubleClicked: this._view.showDetailView4Business
    }
    this._view.columnDefs = [
      { headerName: this.$t('Billing.billingCharge_mblNo'), colId: 'mbl', field: 'mbl', width: 180 },
      {
        headerName: this.$t('Billing.billingCharge_carrier'), colId: 'carrierId', field: 'carrierId', width: 180,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
        }
      },
      { headerName: this.$t('Billing.billingCharge_businessDate'), colId: 'businessDate', field: 'businessDate', width: 180,
        cellRenderer: (params) => {
          return DateUtils.formatStandardDate(params.value)
        }
      },
      {
        headerName: this.$t('Billing.billingJob_bookingAgent'), colId: 'bookingAgent', field: 'bookingAgent', width: 180,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
        }
      },
      { headerName: this.$t('Billing.billingCharge_sales'), colId: 'sales', field: 'sales', width: 180,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
        }
      },
      { headerName: this.$t('Billing.billingJob_dateOfDeparture'), colId: 'etd', field: 'etd', width: 180,
        cellRenderer: (params) => {
          return DateUtils.formatStandardDate(params.value)
        }
      },
      { headerName: this.$t('queryJob.totalIncome'), colId: 'income', field: 'income', width: 180,
        cellRenderer: (params) => {
          return ColumnUtils.number2ColumnLabelFunc(params.value)
        }
      },
      { headerName: this.$t('queryJob.totalCost'), colId: 'cost', field: 'cost', width: 180,
        cellRenderer: (params) => {
          return ColumnUtils.number2ColumnLabelFunc(params.value)
        }
      },
      { headerName: this.$t('FinanceManage.charge_profit'), colId: 'realProfit', field: 'realProfit', width: 180,
        cellRenderer: (params) => {
          return ColumnUtils.number2ColumnLabelFunc(params.value)
        }
      },
      { headerName: this.$t('Clearing.AgeOfAccount'), colId: 'chargeDateApart', field: 'chargeDateApart', width: 180 },
      { headerName: this.$t('Clearing.CommissionAmount'), colId: 'commissionAmount', field: 'commissionAmount', width: 180,
        cellRenderer: (params) => {
          return params.value ? ColumnUtils.number2ColumnLabelFunc(params.value) : ''
        }
      },
      { headerName: this.$t('Clearing.TradeType'), colId: 'incoTerm', field: 'incoTerm', width: 180 },
      { headerName: this.$t('Clearing.PayableWriteOffStatus'), colId: 'due', field: 'due', width: 180 },
      { headerName: this.$t('Clearing.ReceivableWriteOffStatus'), colId: 'receivable', field: 'receivable', width: 180 },
      { headerName: this.$t('Billing.billingCharge_accrued'), colId: 'provisioned', field: 'provisioned', width: 180,
        cellRenderer: (params) => {
          return ColumnUtils.booleanLabelFunction(params.value)
        }
      },
      { headerName: this.$t('queryJob.accrualDate'), colId: 'provisionedDate', field: 'provisionedDate', width: 180 }
    ]
  }
}
